import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useTheme, useMediaQuery } from '@material-ui/core';

const progressiveImage = ({ placeholder, src, loading = "lazy" }) => {
  const [imageLoaded, setImageLoaded] = useState(false);
  const theme = useTheme();
  const isXs = useMediaQuery(theme.breakpoints.down('xs')); // Check if screen is xs

  useEffect(() => {
    // Only preload if loading="eager", otherwise let browser handle lazy loading
    if (loading === "eager") {
      const image = new Image();
      image.onload = () => {
        setImageLoaded(true);
      };
      image.onerror = () => {
        // Keep placeholder if main image fails to load
        console.warn(`Failed to load image: ${src}`);
      };
      image.src = src;
    } else {
      // For lazy images, mark as loaded immediately so browser handles it
      setImageLoaded(true);
    }
  }, [src, loading]);

  // Build image attributes conditionally for React 16 compatibility
  const imgProps = {
    src: imageLoaded ? src : placeholder,
    style: {
      height: '100%',
      width: '100%',
      objectFit: "cover",
      objectPosition: "center",
      transition: 'opacity 0s',
    },
    alt: "content",
    loading: loading,
    decoding: "async",
    width: "2000",
    height: "765",
    ...(loading === "eager" && { fetchPriority: "high" }) // Use camelCase for React 16
  };

  return (
    <div style={{
        width:"100%",
        height: isXs ? "60vw" : "auto", // Adjust height for xs screens
        overflow: "hidden",
        aspectRatio: '2000/765',
        objectFit: "cover",
        objectPosition: "center",
        display: "flex",
        alignItems: "center",
      }}
    >
      <img {...imgProps} />
    </div>
  );
};

export default progressiveImage;


progressiveImage.propTypes = {
  placeholder: PropTypes.string,
  src: PropTypes.string,
  loading: PropTypes.string,
};